export default "__VITE_ASSET__nKE3FO8r__"